var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGripLinesVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 17,
    viewBox: "0 0 6 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.9286C2 16.25 1.75 16.5 1.5 16.5H1C0.71875 16.5 0.5 16.25 0.5 15.9286V1.07143C0.5 0.785714 0.71875 0.5 1 0.5H1.5C1.75 0.5 2 0.785714 2 1.07143V15.9286ZM5.5 15.9286C5.5 16.25 5.25 16.5 5 16.5H4.5C4.21875 16.5 4 16.25 4 15.9286V1.07143C4 0.785714 4.21875 0.5 4.5 0.5H5C5.25 0.5 5.5 0.785714 5.5 1.07143V15.9286Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGripLinesVertical);
export default __webpack_public_path__ + "static/media/grip-lines-vertical.453b7ef1.svg";
export { ForwardRef as ReactComponent };